const sharePerson = [

    {
        width: 300,
        height: 380
    },

    {
        width: 300,
        height: 380
    },

    {
        width: 300,
        height: 413
    },

    {
        width: 300,
        height: 380
    },

    {
        width: 300,
        height: 380
    },

    {
        width: 300,
        height: 380
    },

    {
        width: 300,
        height: 380
    },

    {
        width: 300,
        height: 380
    },
    {
        width: 300,
        height: 380
    },
    {
        width: 300,
        height: 397
    }

]

export default sharePerson